<template>
  <div class="progress-wrap">
    <f7-progressbar :progress="progressPct" class="progress-track" />
    <div class="progress-labels">
      <span>{{ goalLabel }}</span>
      <span class="progress-pct">{{ progressPct }}%</span>
    </div>
  </div>
</template>

<script setup>
import { toRef } from 'vue'
import { useCampaign } from '../../composables/useCampaign.js'

const props = defineProps({ campaign: { type: Object, default: null } })
const campaignRef = toRef(props, 'campaign')
const { progressPct, goalLabel } = useCampaign(campaignRef)
</script>

<style scoped>
.progress-wrap { padding: 4px 16px 10px; }
.progress-track {
  --f7-progressbar-height: 6px;
  --f7-progressbar-bg-color: var(--f7-list-item-border-color, #e0e0e0);
  --f7-progressbar-border-radius: 3px;
}
.progress-labels {
  display: flex; justify-content: space-between;
  font-size: 12px; color: var(--f7-on-surface-variant, #8e8e93);
  margin-top: 5px;
}
.progress-pct { font-weight: 500; color: var(--f7-theme-color); }
</style>
